import React, { createContext, useContext, useState } from 'react';
var PTCContext = createContext(undefined);
export var PTCProvider = function (_a) {
    var children = _a.children;
    var _b = useState(''), ptcNickname = _b[0], setPtcNickname = _b[1];
    return (React.createElement(PTCContext.Provider, { value: { ptcNickname: ptcNickname, setPtcNickname: setPtcNickname } }, children));
};
export var usePTC = function () {
    var context = useContext(PTCContext);
    if (context === undefined) {
        throw new Error('usePTC must be used within a PTCProvider');
    }
    return context;
};
